export const URLs = {
  HOME: '/',
};

export const ReducerNames = {
  COMMON: 'Common',
};
